import React, { useEffect, useState } from "react";
import logo from "./logo.png";
import "./App.css";
import { styled } from "@mui/material/styles";
import skip from "./skip.png";
import { Button } from "@mui/material";
import { LoadingButton } from "@mui/lab";
import Option from "./Options";
import InputCard from "./InputCard";
import axios from "axios";

// const bg = require("./bg.jpeg");
const skipcashBlue = "#1e3f91";

const ColorButton = styled(Button)(({ theme }) => ({
	color: theme.palette.getContrastText(skipcashBlue),
	backgroundColor: skipcashBlue,
	color: "white",
	textTransform: "capitalize",
	fontStyle: "Poppins",

	"&:hover": {
		backgroundColor: "white",
		borderColor: skipcashBlue,
		borderWidth: 1,
		borderStyle: "solid",
		color: skipcashBlue,
		textTransform: "capitalize",
		fontStyle: "Poppins",
	},
}));

function App() {
	const [windowDimensions, setWindowDimensions] = useState(
		getWindowDimensions()
	);
	const [name, setName] = useState({ value: "", err: false, errTxt: "" });
	const [middleName, setMiddleName] = useState({
		value: "",
		err: false,
		errTxt: "",
	});
	const [lastname, setLastName] = useState({
		value: "",
		err: false,
		errTxt: "",
	});
	const [dob, setDob] = useState({ value: "", err: false, errTxt: "" });
	const [gender, setGender] = useState({ value: "", err: false, errTxt: "" });
	const [idnumber, setId] = useState({ value: "", err: false, errTxt: "" });
	const [managername, setManagerName] = useState({
		value: "",
		err: false,
		errTxt: "",
	});
	const [phone, setPhone] = useState({ value: "", err: false, errTxt: "" });
	const [email, setEmail] = useState({ value: "", err: false, errTxt: "" });
	const [teamname, setTeamName] = useState({
		value: "",
		err: false,
		errTxt: "",
	});
	const [amount, setAmount] = useState(0);
	const [clicked, setClicked] = useState(false);
	const [isChecked, setIsChecked] = useState(false);
	const [closed, setClosed] = useState(true);
	const options = ["Male", "Female"];
	function getWindowDimensions() {
		const { innerWidth: width, innerHeight: height } = window;
		return {
			width,
			height,
		};
	}
	const [file, setFile] = useState(null);
	const [uploaded, setUploaded] = useState(false);

	const handleFileChange = (event) => {
		const file = event.target.files[0];
		setFile(file);
	};
 const handleChange = () => {
    setIsChecked(!isChecked);
  };
	const handleUpload = async () => {
		console.log("file : ", file);
		console.log("idNumber : ", idnumber.value);
		if (!file) {
			alert("Please select a file first!");
			return;
		}

		if (idnumber.value != "") {
			const formData = new FormData();
			formData.append("idNumber", idnumber.value);
			formData.append("file-name", file.name);
			formData.append("file", file);

			if (
				file.type === "application/pdf" ||
				file.type === "image/png" ||
				file.type === "image/jpeg" ||
				file.type === "image/jpg"
			) {
				// "https://alrami.skipcash.com/api/upload/uploadFile",
				try {
					axios
						.post("https://alrami.skipcash.com/api/upload/uploadFile", formData)
						.then((response) => {
							setUploaded(true);
						})
						.catch((err) => {
							alert("Failed to upload file");
						});
				} catch (error) {
					console.error("Upload failed:", error);
				}
			} else {
				alert("Error: Files of this type are not allowed!");
			}
		} else {
			alert("Please enter Id number");
		}
	};
	useEffect(() => {
		function handleResize() {
			setWindowDimensions(getWindowDimensions());
		}

		window.addEventListener("resize", handleResize);
		return () => window.removeEventListener("resize", handleResize);
	}, []);

	const handleData = (value, field) => {
		if (field === "name") setName({ value, err: false, errTxt: "" });
		else if (field === "lastname")
			setLastName({ value, err: false, errTxt: "" });
		else if (field === "middleName")
			setMiddleName({ value, err: false, errTxt: "" });
		else if (field === "phone") setPhone({ value, err: false, errTxt: "" });
		else if (field === "idnumber") setId({ value, err: false, errTxt: "" });
		else if (field === "dob") {
			setDob({ value, err: false, errTxt: "" });
			let first = value.split("-");
			let year = first[0];
			console.log("dob : ", year);
			// if (
			// 	year == 2016 ||
			// 	year == 2015 ||
			// 	year == 2014 ||
			// 	year == 2013 ||
			// 	year == 2012 ||
			// 	year == 2011 ||
			// 	year == 2010 
			// ) {
			if (year <= 2016){
				setAmount(300);
			}else if (year > 2016) {
				alert("Child cannot be less than 10 years old");
			}
			// } else if (year < 2010) {
			// 	setAmount(500);
			// } else {
			// 	setAmount(0);
			// 	alert("Child cannot be less than 10 years old");
			// }
		} else if (field === "gender") {
			console.log("here");
			setGender({ value, err: false, errTxt: "" });
		} else if (field === "middleName")
			setMiddleName({ value, err: false, errTxt: "" });
		else console.log("All good");
	};
	const validateEmail = (email) => {
		return /^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/g.test(email);
	};
	const pay = async () => {
		console.log("here");
		const nameRegEx = /^[A-Za-z ]+$/;
		const numRegEx = new RegExp("^[0-9]*$");
		console.log("the firname :", name.value);
		console.log("the lastname :", lastname.value);
		console.log("middle name : ", middleName.value);
		console.log("the dob :", dob.value);
		console.log("the id :", idnumber.value);
		console.log("the gender :", gender.value);
		console.log("the phone :", phone.value);
		setClicked(true);
		if (name.value === "" || lastname.value === "" || middleName.value === "") {
			setName({ value: "", err: true, errTxt: "Name cannot be empty" });
			setLastName({
				value: "",
				err: true,
				errTxt: "Last Name cannot be empty",
			});
			setMiddleName({
				value: "",
				err: true,
				errTxt: "Middle Name cannot be empty",
			});
			setClicked(false);
			return;
		}
		if (!nameRegEx.test(name.value)) {
			setName({
				value: "",
				err: true,
				errTxt: "Name can only have English Letters",
			});
			setClicked(false);
			return;
		}
		if (middleName.value === "") {
			setMiddleName({
				value: "",
				err: true,
				errTxt: "Middle Name cannot be empty",
			});
			setClicked(false);
			return;
		}
		if (!nameRegEx.test(middleName.value)) {
			setMiddleName({
				value: "",
				err: true,
				errTxt: "Middle Name can only have English Letters",
			});
			setClicked(false);
			return;
		}
		if (lastname.value === "") {
			setLastName({
				value: "",
				err: true,
				errTxt: "Last Name cannot be empty",
			});
			setClicked(false);
			return;
		}
		if (!nameRegEx.test(lastname.value)) {
			setLastName({
				value: "",
				err: true,
				errTxt: "Last Name can only have English Letters",
			});
			setClicked(false);
			return;
		}
		// if (idnumber.value === "") {
		//   setId({ value: "", err: true, errTxt: "ID cannot be empty" });
		//   setClicked(false);
		//   return;
		// }
		if (gender.value === "") {
			setGender({ value: "", err: true, errTxt: "Gender cannot be empty" });
			setClicked(false);
			return;
		}
		if (dob.value === "") {
			setDob({ value: "", err: true, errTxt: "Date Of Birth cannot be empty" });
			setClicked(false);
			return;
		}
		if (idnumber.value === "") {
			setDob({ value: "", err: true, errTxt: "ID number cannot be empty" });
			setClicked(false);
			return;
		}

		if (phone.value === "") {
			setPhone({
				value: "",
				err: true,
				errTxt: "Phone Number cannot be empty",
			});
			setClicked(false);
			return;
		}
		if (!numRegEx.test(phone.value)) {
			setPhone({
				value: "",
				err: true,
				errTxt: "Invalid Phone Number",
			});
			setClicked(false);
			return;
		}
		if (amount === 0) {
			alert("Please select a valid date of birth");
			setClicked(false);
			return;
		}
		if (!uploaded) {
			alert("Please upload id");

		}

		// if (!validateEmail(email.value)) {
		//   setEmail({
		//     value: "",
		//     err: true,
		//     errTxt: "Invalid Email",
		//   });
		//   setClicked(false);
		//   return;
		// }
		if (!isChecked){
			alert("Please Agree to the terms and conditions")
			setClicked(false);
			return;
		}

		if (parseInt(amount.value) > 60000) {
			alert("Total Amount Should Be Less than 60000");
			setClicked(false);

			return;
		}
		const url = "https://alrami.skipcash.com/api/payment/pay";
		const response = await fetch(url, {
			method: "POST",
			headers: {
				"Content-Type": "application/json",
			},
			body: JSON.stringify({
				name: `${name.value} ${middleName.value}`,
				middleName: middleName.value,
				lastName: lastname.value,
				phoneNumber: phone.value,
				dob: dob.value,
				gender: gender.value,
				idNumber: idnumber.value,
				desc: `gender: ${gender.value}, id: ${idnumber.value}, dob: ${dob.value}`,
				amount: `${amount}.00`,
			}),
		});
		const json = await response.json();

		window.location = json.payUrl;
	};

	const styles = {
		container: {
			backgroundColor: "#242424",
			width: "100%",
			height:
				windowDimensions.width <= 380
					? "140vh"
					: windowDimensions.width <= 500
					? "120vh"
					: windowDimensions.width > 500 && windowDimensions.width < 1000
					? "120vh"
					: windowDimensions.width < 1500
					? "200vh"
					: "200vh",
			margin: 0,
			display: "flex",
			overflow: "hidden",
			flex: 1,
			flexDirection: "column",
			minHeight: "100%",
		},
		whiteContainer: {
			display: "flex",
			justifyContent: "center",
			paddingTop: "5%",
			paddingBottom: "6%",
			height:
				windowDimensions.width <= 380
					? "140vh"
					: windowDimensions.width <= 500
					? "120vh"
					: windowDimensions.width > 500 && windowDimensions.width < 1000
					? "120vh"
					: windowDimensions.width < 1500
					? "160vh"
					: "160vh",
		},
		fontSizeStyle: {
			fontFamily: "Poppins",
			fontSize:
				windowDimensions.width <= 380
					? "0.75em"
					: windowDimensions.width <= 500
					? "0.8em"
					: windowDimensions.width > 500 && windowDimensions.width < 600
					? "1em"
					: windowDimensions.width >= 600 && windowDimensions.width < 1000
					? "1em"
					: windowDimensions.width < 1500
					? "1em"
					: "1em",
		},
		headerFontStyle: {
			fontFamily: "Poppins",
			fontSize:
				windowDimensions.width <= 380
					? "1.2em"
					: windowDimensions.width <= 500
					? "1.4em"
					: windowDimensions.width > 500 && windowDimensions.width < 600
					? "1.4em"
					: windowDimensions.width >= 600 && windowDimensions.width < 1000
					? "1.8em"
					: windowDimensions.width < 1500
					? "1.9em"
					: "2em",
		},
		mobileButton: {
			width: "100%",
			padding: "5%",
			borderRadius: 10,
			fontStyle: "Poppins",
			fontSize: "1em",
			height: 40,
		},
		desktopButton: {
			width: "100%",
			padding: "2%",
			borderRadius: 10,
			fontStyle: "Poppins",
			fontSize: "1.2em",
			height: 20,
		},
	};

	return (
		
		<div style={styles.container}>
			{console.log(windowDimensions.width, windowDimensions.height)}
			<div style={styles.whiteContainer}>
				{closed ?
				(
			<div><h1>Link Not Available</h1>
			</div>
				)
			:
			
				<div
					style={{
						borderWidth: 1,
						borderStyle: "solid",
						borderColor: "transparent",
						borderRadius: 10,
						width: "90%",
						background: "white",
					}}
				>
					<div
						style={{
							display: "flex",
							justifyContent: "center",
							alignItems: "center",
							paddingTop: "0.5%",
						}}
					>
						<img
							src={logo}
							style={{ height: windowDimensions.height / 5, borderRadius: 10 }}
						/>
					</div>
					{/* <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              paddingTop: "0.5%",
            }}
          >
            <h1>Link Not Available</h1>
          </div> */}

					{uploaded ? (
						<>
							<div
								style={{
									marginLeft: "5%",
									marginRight: "5%",
								}}
							>
								<InputCard
									label={"Name"}
									handleData={handleData}
									err={name.err}
									errTxt={name.errTxt}
									fontStyle={styles.fontSizeStyle}
									options={false}
									field={"name"}
									type={"text"}
								/>
								<InputCard
									label={"Middle Name"}
									handleData={handleData}
									err={middleName.err}
									errTxt={middleName.errTxt}
									fontStyle={styles.fontSizeStyle}
									options={false}
									field={"middleName"}
									type={"text"}
								/>
								<InputCard
									label={"Last Name"}
									handleData={handleData}
									err={lastname.err}
									errTxt={lastname.errTxt}
									fontStyle={styles.fontSizeStyle}
									options={false}
									field={"lastname"}
									type={"text"}
								/>

								<h5>Gender</h5>
								<div
									style={{
										marginTop: "1%",
										display: "flex",
										justifyContent: "space-between",
									}}
								>
									<Option
										categories={options}
										handleData={handleData}
										label={"Gender"}
										fontStyle={styles.fontSizeStyle}
										field={"gender"}
										fullWidth
										style={{ width: "48%" }}
									/>
								</div>

								<InputCard
									label={"Date Of Birth"}
									handleData={handleData}
									err={dob.err}
									errTxt={dob.errTxt}
									fontStyle={styles.fontSizeStyle}
									options={false}
									field={"dob"}
									type={"date"}
								/>
								<InputCard
									label={"Phone Number"}
									handleData={handleData}
									err={phone.err}
									errTxt={phone.errTxt}
									fontStyle={styles.fontSizeStyle}
									options={false}
									field={"phone"}
									type={"text"}
								/>
  <input
          type="checkbox"
          checked={isChecked}
          onChange={handleChange}
        />
     I agree to the Terms and Conditions
								<div
									style={{
										display: "flex",
										flexDirection: "row",
										justifyContent: "space-between",
									}}
								>
									<h3 style={styles.fontSizeStyle}>{`Total`}</h3>
									<h3 style={styles.fontSizeStyle}>{`${amount} QAR`}</h3>
								</div>
							</div>

							<div
								style={{
									height:
										windowDimensions.width < 1000
											? windowDimensions.height / 6
											: windowDimensions.height / 4,
									display: "flex",
									justifyContent: "space-between",
									alignItems: "center",
									flexDirection: "column",
								}}
							>
								<div style={{ width: "90%", marginTop: "2%" }}>
									{clicked ? (
										<LoadingButton
											loading
											variant="outlined"
											style={
												windowDimensions.width < 1000
													? {
															width: "100%",
															padding: "5%",
															borderRadius: 10,
															fontStyle: "Poppins",
															fontSize: "0.5em",
															height: 40,
													  }
													: {
															width: "100%",
															padding: "2%",
															borderRadius: 10,
															fontStyle: "Poppins",
															fontSize: "1em",
															height: 20,
													  }
											}
										>
											SUBMIT
										</LoadingButton>
									) : (
										<ColorButton
											onClick={() => pay()}
											style={
												windowDimensions.width < 1000
													? {
															width: "100%",
															padding: "5%",
															borderRadius: 10,
															fontStyle: "Poppins",
															fontSize: "1em",
															height: 40,
													  }
													: {
															width: "100%",
															padding: "2%",
															borderRadius: 10,
															fontStyle: "Poppins",
															fontSize: "1.2em",
															height: 20,
													  }
											}
										>
											Proceed to Pay
										</ColorButton>
									)}
								</div>
							</div>
						</>
					) : (
						<div
							style={{
								marginLeft: "5%",
								marginRight: "5%",
							}}
						>
							<InputCard
								label={"ID Number"}
								handleData={handleData}
								err={idnumber.err}
								errTxt={idnumber.errTxt}
								fontStyle={styles.fontSizeStyle}
								options={false}
								field={"idnumber"}
								type={"text"}
							/>

							<InputCard
								label={"ID"}
								handleData={handleFileChange}
								fontStyle={styles.fontSizeStyle}
								options={false}
								field={"file"}
								type={"file"}
							/>
							{/* <input
								style={{ marginTop: "40px" }}
								type="file"
								onChange={handleFileChange}
							/> */}

							<div
								style={{
									height:
										windowDimensions.width < 1000
											? windowDimensions.height / 6
											: windowDimensions.height / 4,
									display: "flex",
									justifyContent: "space-between",
									alignItems: "center",
									flexDirection: "column",
								}}
							>
								<div style={{ width: "90%", marginTop: "2%" }}>
									{clicked ? (
										<LoadingButton
											loading
											variant="outlined"
											style={
												windowDimensions.width < 1000
													? {
															width: "100%",
															padding: "5%",
															borderRadius: 10,
															fontStyle: "Poppins",
															fontSize: "0.5em",
															height: 40,
													  }
													: {
															width: "100%",
															padding: "2%",
															borderRadius: 10,
															fontStyle: "Poppins",
															fontSize: "1em",
															height: 20,
													  }
											}
										>
											SUBMIT
										</LoadingButton>
									) : (
										<ColorButton
											onClick={() => handleUpload()}
											style={
												windowDimensions.width < 1000
													? {
															width: "100%",
															padding: "5%",
															borderRadius: 10,
															fontStyle: "Poppins",
															fontSize: "1em",
															height: 40,
													  }
													: {
															width: "100%",
															padding: "2%",
															borderRadius: 10,
															fontStyle: "Poppins",
															fontSize: "1.2em",
															height: 20,
													  }
											}
										>
											Upload ID
										</ColorButton>
									)}
								</div>
							</div>
							{/* <button onClick={handleUpload}>Upload</button> */}
						</div>
					)}
				</div>
}
			</div>

		</div>
	);
}

export default App;
